import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from "js-cookie";
import api from "../../AxiosInstance/AxiosInstance";
import axios from 'axios';

const FinancialYear = Cookies.get("FinancialYear");
const Firm = Cookies.get("Firm");

const DataBase = Cookies.get("Database");
const token = Cookies.get("authToken");


const BaseURL = process.env.REACT_APP_API_URL;

// -------------------dashboard ------------------

export const OverallDashBoard = createAsyncThunk(
    'DashBoard/OverallDashBoard',
    async (data, { rejectWithValue }) => {

        try {
            const response = await axios.post(`${BaseURL}/DashBoard/OverallDashBoard `, {
                FirmIDs: Firm,
                AcYearIDs: FinancialYear,
                DataBase: DataBase,
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : ""
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const FinishMeterSummery = createAsyncThunk(
    'Gray/FinishMeter',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/Gray/FinishMeter`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.AcIDs ? data.AcIDs : "",
                ProductionGroupMstIDs: data.ProductionGroupMstIDs ? data.ProductionGroupMstIDs : ""
            },);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const GreyDashboardData = createAsyncThunk(
    'DashBoard/GreyDashboardData',
    async (_, { rejectWithValue }) => { // Added _ for unused data param, and rejectWithValue
        try {
            const response = await api.post(`/DashBoard/GreyDashboardData`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                AcIDs: "",
                ProductionGroupMstIDs: "",
                AcYearIDs: FinancialYear,
                MonthIDxs: "",
            },);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const GrayDashBoardchart1 = createAsyncThunk(
    'DashBoard/GrayDashBoardchart1',
    async (_, { rejectWithValue }) => { // Added _ and rejectWithValue
        try {
            const response = await api.post(`/DashBoard/GrayDashBoardchart1`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: "",
                ProductionGroupMstIDs: "",
                MonthIDxs: "",
            },);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);



export const GrayDashBoardchart2 = createAsyncThunk(
    'DashBoard/GrayDashBoardchart2',
    async (_, { rejectWithValue }) => { // Added _ and rejectWithValue
        try {
            const response = await api.post(`/DashBoard/GrayDashBoardchart2`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: "",
                ProductionGroupMstIDs: "",
                MonthIDxs: "",
            },);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);


// ------------------opening-----------------

export const OpeninMeter = createAsyncThunk(
    'Gray/OpeninMeter',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/Gray/Dcharts`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.partyIDs,
                ProductionGroupMstIDs: data.groupIDs,
                MonthIDxs: "",
            },);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Network Error');
        }
    }
);

export const MasterWise = createAsyncThunk(
    'Gray/MasterWise',
    async (data) => {

        try {
            const response = await api.post(`/Gray/MasterWise`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.partyIDs,
                ProductionGroupMstIDs: data.groupIDs,
                MonthIDxs: "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error sdsf');
        }
    }
);

export const QualityWise1 = createAsyncThunk(
    'Gray/Quality',
    async (data) => {
        try {
            const response = await api.post(`/Gray/Quality`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.partyIDs,
                ProductionGroupMstIDs: data.groupIDs,
                MonthIDxs: "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error fdsdfds');
        }
    }
);

export const PartyWise1 = createAsyncThunk(
    'Gray/Party',
    async (data) => {
        try {
            const response = await api.post(`/Gray/Party`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.partyIDs,
                ProductionGroupMstIDs: data.groupIDs,
                MonthIDxs: "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error sdfsdf');
        }
    }
);

export const Delhivery1 = createAsyncThunk(
    'Gray/Dcharts1',
    async (data) => {
        try {
            const response = await api.post(`/Gray/Dcharts1`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.partyIDs ? data.partyIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                MonthIDxs: "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error sdfsf');
        }
    }
);


export const GroupWiseSummery = createAsyncThunk(
    'Gray/GroupWiseSummery',
    async (data) => {
        try {
            const response = await api.post(`/Gray/GroupWiseSummery`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                MonthIDxs: "",
                StartDate: data.startDate ? data.startDate : "",
                EndDtate: data.endDate ? data.endDate : "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const GroupandPartyWiseSummery = createAsyncThunk(
    'Gray/GroupandPartyWiseSummery',
    async (data) => {
        try {
            const response = await api.post(`/Gray/GroupandPartyWiseSummery`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.partyIDs ? data.partyIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                MonthIDxs: "",
                StartDate: data.startDate ? data.startDate : "",
                EndDtate: data.endDate ? data.endDate : "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const QualityListwise = createAsyncThunk(
    'Gray/QualityList',
    async (data) => {
        try {
            const response = await api.post(`/Gray/QualityList`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.partyIDs ? data.partyIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const QualityWiseSummery = createAsyncThunk(
    'Gray/QualityWise',
    async (data) => {
        try {
            const response = await api.post(`/Gray/QualityWise`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.partyIDs ? data.partyIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDtate: data.endDate ? data.endDate : "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);


export const MonthWiseSummery = createAsyncThunk(
    'Gray/MonthWiseSummery',
    async (data) => {
        try {
            const response = await api.post(`/Gray/MonthWiseSummery`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                MonthIDxs: "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.partyIDs ? data.partyIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDtate: data.endDate ? data.endDate : " ",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const GroupWiseBalSummery = createAsyncThunk(
    'Gray/GroupWiseBalSummery',
    async (data) => {
        try {
            const response = await api.post(`/Gray/GroupWiseBalSummery`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: data.AcYearIDs ? data.AcYearIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                PgYear: data.PgYear ? data.PgYear : "",
                AcIDs: data.partyIDs ? data.partyIDs : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                // StartDate: data.StartDate ? data.StartDate : "",
                // EndDtate: data.EndDtate ? data.EndDtate : "",
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const PartyWiseBalSummery = createAsyncThunk(
    'Gray/PartyWiseBalSummery',
    async (data) => {

        try {
            const response = await api.post(`/Gray/PartyWiseBalSummery`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: data.AcYearIDs ? data.AcYearIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                AcIDs: data.partyIDs ? data.partyIDs : "",
                PgYear: data.PgYear ? data.PgYear : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                // StartDate: data.StartDate ? data.StartDate : "",
                // EndDtate: data.EndDtate ? data.EndDtate : "",
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const YearWiseBalSummery = createAsyncThunk(
    'Gray/YearWiseBalSummery',
    async (data) => {

        try {
            const response = await api.post(`/Gray/YearWiseBalSummery`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: data.AcYearIDs ? data.AcYearIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                PgYear: data.PgYear ? data.PgYear : "",
                StartDate: data.StartDate ? data.StartDate : " ",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.partyIDs ? data.partyIDs : "",

            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const QualityWiseBalSummery = createAsyncThunk(
    'Gray/QualityWiseBalSummery',
    async (data) => {
        try {
            const response = await api.post(`/Gray/QualityWiseBalSummery`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: data.AcYearIDs ? data.AcYearIDs : "",
                ProductionGroupMstIDs: data.groupIDs ? data.groupIDs : "",
                AcIDs: data.partyIDs ? data.partyIDs : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                PgYear: data.PgYear ? data.PgYear : "",
                // StartDate: data.StartDate ? data.StartDate : "",
                // EndDtate: data.EndDtate ? data.EndDtate : "",
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);


export const GreyInwardDay = createAsyncThunk(
    'DayWise/GreyInwardDay',
    async (data) => {
        try {
            const response = await api.post(`/DayWise/GreyInwardDay`, {
                FirmIDs: data.Firm ? data.Firm : "",
                DataBase: DataBase,

                AcYearIDs: data.AcYearIDs ? data.AcYearIDs : "",
                ProductionGroupMstIDs: data.ProductionGroupMstIDs ? data.ProductionGroupMstIDs : " "
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error dfsdf');
        }
    }
);

export const GreyInwardDayparty = createAsyncThunk(
    'DayWise/GreyInwardDayparty',
    async (data) => {
        try {
            const response = await api.post(`/DayWise/GreyInwardDayparty`, {
                FirmIDs: data.Firm ? data.Firm : "",
                DataBase: DataBase,

                ProductionGroupMstIDs: data.ProductionGroupMstIDs ? data.ProductionGroupMstIDs : "",
                Day: data.Day ? data.Day : "",
                Montyh: data.Month ? data.Month : "",
                AcYearIDs: data.FAcYearID ? data.FAcYearID : "",
            },);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error sdfsdf');
        }
    }
);


export const GreyDashBordSlice = createSlice({
    name: 'greyDashBord',
    initialState: {

        FinishMeterSummerydata: null,
        greydata: null,
        chart1data: null,
        chart2data: null,
        OpeninMeterdata: null,
        MasterWisedata: null,
        PartyWisedata: null,
        QualityWisedata: null,
        Delhiverydata: null,
        GroupWiseSummerydata: null,
        GroupandPartyWiseSummerydata: null,
        QualityListdata: null,
        QualityWiseSummerydata: null,
        MonthWiseSummerydata: null,
        QualityWiseBalSummerydata: null,
        YearWiseBalSummerydata: null,
        PartyWiseBalSummerydata: null,
        GroupWiseBalSummerydata: null,
        GreyInwardDaydata: null,
        GreyInwardDaypartydata: null,
        OverallDashBoard: null,
        OverallDashBoardata: null,

    },
    reducers: {

        resetOverallDashBoardata: (state) => {
            state.OverallDashBoardata = null;
        },
        resetFinishMeterSummery: (state) => {
            state.FinishMeterSummerydata = null;
        },
        resetGreyDashboardData: (state) => {
            state.greydata = null;
        },
        resetGrayDashBoardchart1: (state) => {
            state.chart1data = null;
        },
        resetGrayDashBoardchart2: (state) => {
            state.chart2data = null;
        },
        resetOpeninMeter: (state) => {
            state.OpeninMeterdata = null;
        },
        resetMasterWise: (state) => {
            state.MasterWisedata = null;
        },
        resetPartyWise: (state) => {
            state.PartyWisedata = null;
        },
        resetQualityWise: (state) => {
            state.QualityWisedata = null;
        },
        resetDelhivery: (state) => {
            state.Delhiverydata = null;
        },
        resetGroupWiseSummery: (state) => {
            state.GroupWiseSummerydata = null;
        },
        resetGroupandPartyWiseSummery: (state) => {
            state.GroupandPartyWiseSummerydata = null;
        },
        resetQualityList: (state) => {
            state.QualityListdata = null;
        },
        resetQualityWiseSummery: (state) => {
            state.QualityWiseSummerydata = null;
        },
        resetMonthWiseSummery: (state) => {
            state.MonthWiseSummerydata = null;
        },
        resetQualityWiseBalSummery: (state) => {
            state.QualityWiseBalSummerydata = null;
        },
        resetYearWiseBalSummery: (state) => {
            state.YearWiseBalSummerydata = null;
        },
        resetPartyWiseBalSummery: (state) => {
            state.PartyWiseBalSummerydata = null;
        },
        resetGroupWiseBalSummery: (state) => {
            state.GroupWiseBalSummerydata = null;
        },
        resetGreyInwardDay: (state) => {
            state.GreyInwardDaydata = null;
        },
        resetGreyInwardDayparty: (state) => {
            state.GreyInwardDaypartydata = null;
        },
        OverallDashBoard: (state) => {
            state.OverallDashBoard = null;
        },


    },
    extraReducers: (builder) => {

        builder
            .addCase(OverallDashBoard.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(OverallDashBoard.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.OverallDashBoardata = action.payload;
            })
            .addCase(OverallDashBoard.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(FinishMeterSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(FinishMeterSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.FinishMeterSummerydata = action.payload;
            })
            .addCase(FinishMeterSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        // GreyDashboardData
        builder
            .addCase(GreyDashboardData.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(GreyDashboardData.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.greydata = action.payload;
            })
            .addCase(GreyDashboardData.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(GrayDashBoardchart1.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(GrayDashBoardchart1.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.chart1data = action.payload;
            })
            .addCase(GrayDashBoardchart1.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(GrayDashBoardchart2.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(GrayDashBoardchart2.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.chart2data = action.payload;
            })
            .addCase(GrayDashBoardchart2.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });


        builder
            .addCase(OpeninMeter.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(OpeninMeter.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.OpeninMeterdata = action.payload;
            })
            .addCase(OpeninMeter.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(MasterWise.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(MasterWise.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.MasterWisedata = action.payload;
            })
            .addCase(MasterWise.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(PartyWise1.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(PartyWise1.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.PartyWisedata = action.payload;
            })
            .addCase(PartyWise1.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(QualityWise1.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(QualityWise1.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.QualityWisedata = action.payload;
            })
            .addCase(QualityWise1.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });


        builder
            .addCase(Delhivery1.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(Delhivery1.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.Delhiverydata = action.payload;
            })
            .addCase(Delhivery1.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });


        builder
            .addCase(GroupWiseSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(GroupWiseSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.GroupWiseSummerydata = action.payload;
            })
            .addCase(GroupWiseSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });


        builder
            .addCase(GroupandPartyWiseSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(GroupandPartyWiseSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.GroupandPartyWiseSummerydata = action.payload;
            })
            .addCase(GroupandPartyWiseSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(QualityListwise.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(QualityListwise.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.QualityListdata = action.payload;
            })
            .addCase(QualityListwise.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });


        builder
            .addCase(QualityWiseSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(QualityWiseSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.QualityWiseSummerydata = action.payload;
            })
            .addCase(QualityWiseSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(MonthWiseSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(MonthWiseSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.MonthWiseSummerydata = action.payload;
            })
            .addCase(MonthWiseSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(QualityWiseBalSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(QualityWiseBalSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.QualityWiseBalSummerydata = action.payload;
            })
            .addCase(QualityWiseBalSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(YearWiseBalSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(YearWiseBalSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.YearWiseBalSummerydata = action.payload;
            })
            .addCase(YearWiseBalSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(PartyWiseBalSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(PartyWiseBalSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.PartyWiseBalSummerydata = action.payload;
            })
            .addCase(PartyWiseBalSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(GroupWiseBalSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(GroupWiseBalSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.GroupWiseBalSummerydata = action.payload;
            })
            .addCase(GroupWiseBalSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });

        builder
            .addCase(GreyInwardDay.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(GreyInwardDay.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.GreyInwardDaydata = action.payload;
            })
            .addCase(GreyInwardDay.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });



        builder
            .addCase(GreyInwardDayparty.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(GreyInwardDayparty.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.GreyInwardDaypartydata = action.payload;
            })
            .addCase(GreyInwardDayparty.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            });









    },
});

export default GreyDashBordSlice.reducer;
export const {
    resetFinishMeterSummery,
    resetGreyDashboardData,
    resetGrayDashBoardchart1,
    resetGrayDashBoardchart2,
    resetOpeninMeter,
    resetMasterWise,
    resetQualityWise,
    resetPartyWise,
    resetDelhivery,
    resetGroupWiseSummery,
    resetGroupandPartyWiseSummery,
    resetQualityListdata,
    resetQualityWiseSummery,
    resetMonthWiseSummery,
    resetQualityWiseBalSummery,
    resetYearWiseBalSummery,
    resetPartyWiseBalSummery,
    resetGroupWiseBalSummery,
    resetGreyInwardDay,
    resetGreyInwardDayparty,
    resetOverallDashBoardata



} = GreyDashBordSlice.actions;